// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__ukiAL","list":"PatternAutocomplete_list__38WCw"};